<dashboard-dialog-frame class="acc-venture-dialog" [header]="headerName()" [actions]="actions" [dialogRef]="dialogRef">
	@if(dialogDataService.dialogData(); as data){
	<kendo-tabstrip class="h-100 px-2 pt-2">

		<kendo-tabstrip-tab title="Details" [selected]="true">
			<ng-template kendoTabContent>
				<acc-venture-details-part></acc-venture-details-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Entrepreneurs">
			<ng-template kendoTabContent>
				<acc-venture-entrepreneurs-part [dialogBodyHeight]="dialogContext.dimensions().bodyHeight"></acc-venture-entrepreneurs-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Notes">
			<ng-template kendoTabContent>
				<notes-editor-part [accVentureId]="data.accVentureId"></notes-editor-part>
			</ng-template>
		</kendo-tabstrip-tab>

	</kendo-tabstrip>
	}

</dashboard-dialog-frame>